import { render, staticRenderFns } from "./season-card.vue?vue&type=template&id=5fb1f3e6"
import script from "./season-card.vue?vue&type=script&lang=js"
export * from "./season-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports